import "./Select.css";

type SelectIntrinsicProps = JSX.IntrinsicElements["select"];
interface SelectProps extends SelectIntrinsicProps {
  label: string;
  labelTop?: string;
  labelGap?: string;
}

export default function Select({
  children,
  label,
  className,
  labelTop = "-1em",
  labelGap,
  ...other
}: SelectProps): JSX.Element {
  return (
    <div className="Input__wrapper">
      <label style={{ marginTop: labelTop }} className="Input__label">
        {label}
      </label>
      {labelGap && (
        <span style={{ width: labelGap }}></span>
      )}
      <select {...other} className={className || "select"}>
        {children}
      </select>
    </div>
  );
}
